import React from "react";

// Modify path,title, icons, subnav according to project
export const ChairData = [
  {
    title: "Dashboard",
    path: "/chairDashboard",
    icon: <i className="fa-solid fa-home"></i>,
  },

  {
    title: "Sacco Members",
    path: "/chairMembers",
    icon: <i className="fa-solid fa-user"></i>,
  },

  {
    title: "Sacco Savings",
    path: "/chairShgSavings",
    icon: <i className="fa-solid fa-sack-dollar"></i>,
  },

  {
    title: "Sacco Loans",
    path: "/chairLoans",
    icon: <i className="fa-solid fa-hand-holding-usd"></i>,
  },
];
